import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const entryInfo = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: vars.space["2xs"],
  selectors: {
    "&:not(:first-child)": {
      alignItems: "flex-start",
    },
  },
});

export const entryName = style({
  marginBlock: 0,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading.m,
});

export const playerInfo = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
});

export const playerName = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.s,
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      fontSize: vars.fontSizes.body.m,
    },
  },
});

export const editIcon = style({
  width: 12,
  height: 12,
});

export const editFieldWrap = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  width: "100%",
  maxWidth: 240,
  textAlign: "left",
});

export const editActions = style({
  display: "flex",
  justifyContent: "flex-end",
  gap: vars.space.xs,
});
